import { render } from "./KnowledgeResourceAdminView.vue?vue&type=template&id=79865aef"
import script from "./KnowledgeResourceAdminView.vue?vue&type=script&lang=js"
export * from "./KnowledgeResourceAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__